<template>
  <base-dialog @cancel="cancelDialog">
    <div slot="header">{{ params.title }}</div>
    <div slot="body">
       <a-form
        :form="form.fc">
        <a-form-item :label="$t('scope.text_506')" v-bind="formItemLayout">
          <base-select
            v-decorator="decorators.resource_type"
            class="w-100"
            resource="bill_conditions"
            version="v1"
            idKey="item_id"
            nameKey="item_name"
            :remote="true"
            :needParams="true"
            :params="conditionParams"
            :remote-fn="q => ({ filter: [`item_name.contains(${q})`, `brand.equals(${params.brand})`] })"
            :select-props="{ placeholder: $t('scope.text_507')}"
            @change="resourceTypeChange" />
        </a-form-item>
        <a-form-item :label="$t('common_616')" v-bind="formItemLayout">
          <list-select
            v-decorator="decorators.models"
            :list-props="modelProps"
            :formatter="row => `${row.item_name}`"
            :placeholder="$t('common_617')"
            :items.sync="selectedModels" />
        </a-form-item>
        <a-form-item :label="$t('scope.text_509')" v-bind="formItemLayout">
          <a-row>
            <a-col class="mr-2" :span="19">
              <a-input v-decorator="decorators.price" />
            </a-col>
            <a-col :span="4">
              <a-select v-decorator="decorators.unit" :options="unitOps" />
            </a-col>
          </a-row>
        </a-form-item>
        <a-form-item :label="$t('scope.text_511')" v-bind="formItemLayout">
          <a-date-picker v-decorator="decorators.enable_time" :format="dateFormat" :disabledDate="disabledDate" />
        </a-form-item>
        <a-form-item :label="$t('scope.text_512')" v-bind="formItemLayout">
          <a-textarea v-decorator="decorators.remark" :autoSize="{ minRows: 2, maxRows: 6 }" />
        </a-form-item>
      </a-form>
    </div>
    <div slot="footer">
      <a-button type="primary" @click="handleConfirm" :loading="loading">{{ $t('dialog.ok') }}</a-button>
      <a-button @click="cancelDialog">{{ $t('dialog.cancel') }}</a-button>
    </div>
  </base-dialog>
</template>

<script>
import * as R from 'ramda'
import { mapGetters, mapState } from 'vuex'
import ListSelect from '@/sections/ListSelect'
import DialogMixin from '@/mixins/dialog'
import WindowsMixin from '@/mixins/windows'

export default {
  name: 'CreateDiscountDialog',
  components: {
    ListSelect,
  },
  mixins: [DialogMixin, WindowsMixin],
  data () {
    return {
      loading: false,
      form: {
        fc: this.$form.createForm(this),
      },
      decorators: {
        resource_type: [
          'resource_type',
          {
            initialValue: '',
          },
        ],
        models: [
          'models',
        ],
        price: [
          'price',
          {
            rules: [
              { required: true, message: this.$t('scope.text_513') },
            ],
          },
        ],
        unit: [
          'unit',
          {
            initialValue: '%',
            rules: [
              { required: true, message: this.$t('common_618') },
            ],
          },
        ],
        enable_time: [
          'enable_time',
          {
            rules: [
              { required: true, message: this.$t('scope.text_514') },
            ],
          },
        ],
        remark: [
          'remark',
        ],
      },
      formItemLayout: {
        wrapperCol: {
          span: 20,
        },
        labelCol: {
          span: 4,
        },
      },
      productList: [
        {
          name: this.$t('scope.text_515'),
          value: 'all',
        },
        {
          name: 'ECS',
          value: 'ecs',
        },
        {
          name: 'RDS',
          value: 'rds',
        },
        {
          name: 'CDN',
          value: 'cdn',
        },
      ],
      resource_type: '',
      modelProps: {
        list: this.$list.createList(this, {
          resource: 'bill_conditions',
          apiVersion: 'v1',
          idKey: 'item_id',
          getParams: this.getParam,
          filterOptions: {
            item_name_regexp: {
              label: this.$t('common_186'),
            },
          },
        }),
        columns: [
          {
            field: 'item_name',
            title: this.$t('common_186'),
            minWidth: 80,
          },
          {
            field: 'unit',
            title: this.$t('common_250'),
            width: 80,
          },
        ],
      },
      dateFormat: 'YYYY-MM-DD',
      conditionParams: {
        scope: this.scope,
        admin: true,
        query_type: 'resource_type_sku',
        limit: 10,
      },
      selectedModels: [],
    }
  },
  computed: {
    ...mapGetters(['scope']),
    ...mapState('app', {
      customer: state => state.customer,
    }),
    unitOps () {
      let selectedModelsTypes = this.selectedModels.map(item => {
        return item.unit
      })
      selectedModelsTypes = R.uniq(selectedModelsTypes)
      let ModelsTypesStr = ''
      selectedModelsTypes.map((item, index) => {
        if (index === selectedModelsTypes.length - 1) {
          ModelsTypesStr += item
        } else {
          ModelsTypesStr += item + ' || '
        }
      })
      const ret = [
        { label: '%', value: 'percent' },
        { label: ModelsTypesStr, value: 'amount' },
      ]
      return ret
    },
  },
  methods: {
    getParam () {
      const ret = {
        admin: true,
        query_type: 'usage_type_sku',
      }
      if (this.resource_type) {
        ret.filter = `sku_category.equals("${this.resource_type}")`
      }
      return ret
    },
    resourceTypeChange (e) {
      this.resource_type = e
    },
    disabledDate (currentDate) {
      return currentDate && currentDate < this.$moment()
    },
    doCreate (data) {
      return this.params.onManager('create', {
        managerArgs: {
          data,
        },
      })
    },
    async handleConfirm () {
      this.loading = true
      try {
        let values = await this.form.fc.validateFields()
        values = {
          ...values,
          brand: this.params.brand,
          cloudaccount_id: this.params.cloudaccountId,
          domain_id: this.params.domain_id,
          price_type: values.unit,
          price: values.unit === 'percent' ? values.price / 100 : Number(values.price),
        }
        delete values.unit
        await this.doCreate(values)
        this.loading = false
        this.$message.success(this.$t('scope.text_516'))
        this.cancelDialog()
        // this.params.refresh()
      } catch (error) {
        this.loading = false
        throw error
      }
    },
  },
}
</script>
